module.exports = __webpack_public_path__ + "static/img/monthButton.fc540e2.png";